(function () {
    'use strict';

    ScheduledExportsModalController.$inject = ['$scope', 'modalData', 'hUser', '$state', 'useScheduledExportsFactory', 'userPermissions', '$timeout', 'brandServices'];

    function ScheduledExportsModalController($scope, modalData, hUser, $state, useScheduledExportsFactory, userPermissions, $timeout, brandServices) {
        const self = this;
        const {prepareCreateEditSchedulePayload, prepareSftpPath} = useScheduledExportsFactory($scope);

        self.modalData = modalData;
        self.isSaving = false;
        self.error = null;
        self.scheduledExportsForm = new ScheduledExportsForm($scope, hUser, $state, userPermissions, $timeout, brandServices);
        self.scheduledExportsForm.load(self.modalData, prepareSftpPath);
        const MODAL_MODE = {
            EDIT : 'EDIT'
        }

        self.close = () => {
            $scope.$hide();
        };

        self.save = async () => {
            self.error = null;

            try {
                await self.scheduledExportsForm.validate();
            } catch (e) {
                console.error(e);
                return;
            }

            self.isSaving = true;
            $scope.$digest();

            const brandId = hUser.getActiveBrandIdWithAccess();

            let api = GoodMorningToolEngineAPI.createScheduleExport;
            if (self.modalData.mode === MODAL_MODE.EDIT) {
                api = GoodMorningToolEngineAPI.updateScheduleExport;
            }

            try {
                await api(brandId, prepareCreateEditSchedulePayload(self.scheduledExportsForm.data), self.modalData.id);
            } catch (e) {
                let errorMessage = $filter('translate')('Something went wrong, please try again later');
                if (e?.data?.errors?.[0]?.code === 'NOT_ALLOWED') {
                    errorMessage = e?.data?.errors?.[0]?.detail;
                }
                console.error(e);
                self.error = errorMessage;
                self.isSaving = false;
                $scope.$digest();
                return;
            }

            self.close();
            HNotifications.show({
                title: self.modalData.mode === MODAL_MODE.EDIT ? $filter('translate')('Schedule updated Successfully') : $filter('translate')('Schedule created Successfully'),
                icon: "fa-check",
                type: "success",
                timeout: 3000
            });
            await self.modalData?.callback?.();
            $scope.$digest();
        };
    }

    angular
        .module('harriApp')
        .controller('ScheduledExportsModalController', ScheduledExportsModalController);
})();